import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AdminPrsContent from "./components/adminPrsContent";

function AdminPrs() {
  return (
    <div>
      <TitleHolder>Purchase Requisitions </TitleHolder>
      <StepperContentHolder>
        <AdminPrsContent />
      </StepperContentHolder>
    </div>
  );
}

export default AdminPrs;
